$(window).scroll(function(){
    topbarState();
});

$(document).ready(function() {
    topbarState();
    if($('.home-hero').length){
        randomBG();
    }

    $('.menu-toggle button').click(function() {
        $('.main-menu').toggleClass('collapsed expanded');
        $('body').toggleClass('lock-scroll');
        topbarState();
    });

    if($( window ).width() > 767) {
        $('[data-youtube]').youtube_background(); 
    }

    $('.nav-no-click > a').click(function(e) {
        e.preventDefault();
        /*parentElm = $(this).parent();
        $('.menu > li').each(function() {
            if($(this) == parentElm){
                $(this).toggleClass('showsub');
            } else {
                $(this).removeClass('showsub')
            }
        });*/
        $(this).parent().siblings().removeClass('showsub');
        $(this).parent().toggleClass('showsub');
    });

    $('.hero').each(function( index ) {
        if($( window ).width() > 800){
            if($( window ).width() > 1390){
                $img = $(this).data('image-src-xl');
            } else {
                $img = $(this).data('image-src-md');
            }

            $(this).css('background', 'transparent');
            $(this).parallax({
                imageSrc: $img,
                speed: 0.4,
                bleed: 20
            });
        }
    });

});

function randomBG() {
    var number = Math.floor(Math.random() * numbgs);
    console.log(number);
    $('.home-hero').addClass('bg'+number);

    $('.home-hero').each(function( index ) {
        if($( window ).width() > 800){
            if($( window ).width() > 1390){
                $img = bgxl[number];
            } else {
                $img = bgmd[number];
            }

            $(this).css('background', 'transparent');
            $(this).parallax({
                imageSrc: $img,
                speed: 0.4,
                bleed: 20
            });
        }
    });
}

function topbarState(){
    var scrolled=$(window).scrollTop();
    //console.log(scrolled);
    /*if(scrolled > 50) {
        $('.topbar').addClass('scrolled');
    }else {
        $('.topbar').removeClass('scrolled');
    }*/


    if($('.main-menu').hasClass('expanded') || scrolled > 30){
        $('.topbar').addClass('scrolled');
    } else {
        $('.topbar').removeClass('scrolled');
    }
}